var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlSpace: "preserve",
    viewBox: "138.8 49.5 522 500.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FF060A;}\t.st1{fill:#FFFFFF;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.8,549.7c144.2,0,261-112,261-250.1S544,49.5,399.8,49.5c-144.2,0-261,112-261,250.1  S255.7,549.7,399.8,549.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546.6,254.7c-14.4-12.8-34.4-32.3-50.6-46.1l-1-0.6c-1.6-1.2-3.4-2.2-5.3-2.9l0,0  c-39.2-7-221.6-39.7-225.1-39.3c-1,0.1-2,0.5-2.8,1l-0.9,0.7c-1.1,1.1-2,2.4-2.5,3.9l-0.2,0.6v3.3v0.5  c20.5,54.8,101.6,234.2,117.6,276.4c1,2.9,2.8,8.3,6.2,8.6h0.8c1.8,0,9.6-9.9,9.6-9.9s139.3-161.8,153.4-179  c1.8-2.1,3.4-4.4,4.8-6.8c0.4-1.9,0.2-3.8-0.5-5.6S548.1,256,546.6,254.7L546.6,254.7z M428,273.6l59.4-47.2l34.9,30.8L428,273.6z   M404.9,270.5l-102.3-80.4l165.6,29.3L404.9,270.5z M414.1,291.5l104.7-16.2L399.1,413.6L414.1,291.5z M288.7,198.2l107.7,87.5  l-15.6,128L288.7,198.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.3e497fb7216310a6ed7bfa2c06589a79.svg";
export { ForwardRef as ReactComponent };